import { updateSessionStorage } from '../../utils/storage';

// Actions
export const MULTIPLE_CUSTOMER_REQUESTS = 'MULTIPLE_CUSTOMER_REQUESTS';
export const CUSTOMER_PENDING_REQUESTS = 'CUSTOMER_PENDING_REQUESTS';

// Initial State
export const multiRequestInitialState = {
  requests: []
};

export const UpdateCustomerActiveRequests = requests => {
  const existingHcId = updateSessionStorage.getItem('hcId');
  //update customer active requests
  const result = requests.filter(item => item?.id !== existingHcId);
  return result;
};

// Reducer
export function multiRequest(state = multiRequestInitialState, action) {
  switch (action.type) {
    case MULTIPLE_CUSTOMER_REQUESTS: {
      return { ...state, requests: [...action.payload] };
    }
    case CUSTOMER_PENDING_REQUESTS:
      return { ...state, requests: UpdateCustomerActiveRequests(action.payload) };
    default:
      return state;
  }
}

// Action Creators
export function multipleRequests(payload) {
  return { type: MULTIPLE_CUSTOMER_REQUESTS, payload };
}

export function customerRemainingRequests(payload) {
  return { type: CUSTOMER_PENDING_REQUESTS, payload };
}
